import { FC } from 'react';
import Modal from './FiligraneBaseModal';
import './VideoModal.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const VideoModal: FC<Props> = ({ isOpen, onClose }) => (
  <Modal isOpen={isOpen} onClose={onClose} title="Présentation de l'outil" size="lg">
    <div className="video-modal">
      <div className="video-modal__container">
        <iframe
          src="https://www.youtube.com/embed/bYk4QPlCi5g?start=14&autoplay=1"
          title="Présentation ID Protect — Filigrane"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="video-modal__iframe"
        />
      </div>
    </div>
  </Modal>
);

export default VideoModal;
